// extracted by mini-css-extract-plugin
export var cartIcon = "_ju-0";
export var cartIconContainer = "_ju-1";